export default class FormTools{

    static BtnTxt (clearBtn){
        return clearBtn ? "Save changes" : "Save"
    }
}